export const APP_ROUTE_NAMES = [
    "home",
    "searchresults",
    "searchresults-outbound",
    "searchresults-inbound",
    "flightdetails",
    "flightdetails-outbound",
    "flightdetails-inbound",
    "checkout-start",
    "checkout-ticket-type",
    "checkout-fare",
    "checkout-pax",
    "checkout-extras",
    "checkout-seat-selection",
    "checkout-sirf",
    "checkout-payment",
    "checkout-collection",
    "checkout-ryanair-confirmation",
    "confirmation",
    "pb-order-details",
    "pb-change-flight",
    "pb-rebook-confirmation",
    "pb-find-order",
    "pb-request-refund-my-booking",
    "pb-flight-details",
    "pb-add-baggage",
    "pb-add-fast-track",
    "pb-add-fast-track-confirmation",
    "pricechange",
    "pb-checkout-payment",
    "pb-checkout-confirmation",
    "additional-flights-terms",
    "pb-cancel-order",
    "autocomplete-test",
    "pb-seatmap",
    "pb-web-checkin",
    "pb-web-checkin-v2",
    "not-available",
    "messenger",
    "messenger-ended",
    "not-found",
    "fly-anywhere",
    "alternative-fares",
    "pb-extras"
];
export function isValidRouteName(value) {
    return APP_ROUTE_NAMES.includes(value);
}
export const FLIGHT_DETAILS_ROUTE_PATH = "/flights/:airports/:id";
export const SEARCH_RESULTS_ROUTE_PATH = "/flights/:airports";
export const CHECKOUT_START_ROUTE_PATH = "/checkout/start/:flightToken";
export const FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH = "/flights/:airports/outbound/:id";
export const SEARCH_RESULTS_OUTBOUND_ROUTE_PATH = "/flights/:airports/outbound";
export const FLIGHT_DETAILS_INBOUND_ROUTE_PATH = "/flights/:airports/inbound/:outboundToken/:id";
export const SEARCH_RESULTS_INBOUND_ROUTE_PATH = "/flights/:airports/inbound/:outboundToken";
